import 'angular';

import { DepositCtrl }           from './deposit.ajs';
import { InvoiceDepositService } from './deposits.services';

angular.module('workshop.invoices.deposits', [])
  .controller('DepositCtrl', DepositCtrl)
  .factory('Deposit', InvoiceDepositService);